<template>
  <div v-if="currencySettings.shippingAccountNumber" class="mb-5 w-full">
    <div>
      <button type="button" class="flex w-full text-left" @click="toggleSection">
        <div class="flex items-start gap-1 font-medium leading-6 text-[--color-neutral-a1] underline">
          <VcIcon :name="expandedOption ? 'minus' : 'plus-alt-sm'" :size="7" class="mt-2"></VcIcon>
          {{ $t("shared.checkout.shipping_method_optional") }}
        </div>
      </button>

      <div v-show="expandedOption || shippingAccountNumberRecalculateTotals">
        <VcInput
          v-model="shippingAccountNumberRecalculateTotals"
          :placeholder="$t('shared.checkout.shipping_method_optional_label')"
          maxlength="32"
          class="mt-3 w-full"
        />
        <span class="mt-3 flex text-sm font-medium text-[--color-neutral-a2]">
          {{ $t("shared.checkout.shipping_method_optional_notif") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import type { CurrencySettingsType } from "../../types";

interface IProps {
  currencySettings: CurrencySettingsType;
  shippingAccountNumberRecalculateTotals: string;
}

const emit = defineEmits<{
  "update:shippingAccountNumberRecalculateTotals": [value: string];
}>();

const props = defineProps<IProps>();

const expandedOption = ref(false);

const shippingAccountNumberRecalculateTotals = computed({
  get: () => props.shippingAccountNumberRecalculateTotals,
  set: (value: string) => emit("update:shippingAccountNumberRecalculateTotals", value),
});

const toggleSection = () => {
  expandedOption.value = !expandedOption.value;
};
</script>
